import { spawn } from "node:child_process";
import { resolveClaudeBinary } from "../harness/pty/spawn-args.js";

const PROBE_TIMEOUT_MS = 15_000;

/**
 * Run `<binary> -p "/usage"` and resolve its stdout. Best-effort: resolves an
 * empty string on spawn error, non-zero exit, or timeout — never rejects. The
 * `binary`/`args` params exist for testability; production callers use the defaults.
 */
export function runUsageProbe(
  binary = resolveClaudeBinary(),
  args: string[] = ["-p", "/usage"],
): Promise<string> {
  return new Promise((resolve) => {
    let stdout = "";
    let settled = false;
    const finish = (out: string): void => {
      if (settled) return;
      settled = true;
      resolve(out);
    };

    let child: ReturnType<typeof spawn>;
    try {
      child = spawn(binary, args, { stdio: ["ignore", "pipe", "ignore"] });
    } catch {
      finish("");
      return;
    }

    const timer = setTimeout(() => {
      try {
        child.kill("SIGKILL");
      } catch {
        /* already gone */
      }
      finish("");
    }, PROBE_TIMEOUT_MS);
    timer.unref?.();

    child.stdout?.on("data", (d: Buffer) => {
      stdout += d.toString();
    });
    child.on("error", () => {
      clearTimeout(timer);
      finish("");
    });
    child.on("close", (code) => {
      clearTimeout(timer);
      finish(code === 0 ? stdout : "");
    });
  });
}
